import * as React from 'react';
import { memo } from 'react';

const SvgDedupe = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.438 14.447h4.124v-11h-11v4.125", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.438 7.572h-11v11h11v-11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeDasharray: "3.67 3.67" }),
    React.createElement("path", { d: "m7.39 11.343 3.094 3.459M10.484 11.343l-3.093 3.459", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgDedupe);

export { Memo as default };
